<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><strong>India</strong></p>
<p class="title2">Defending the Jewel in the Crown</p>
<p class="title1">Winston S. Churchill</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?1c8b8b96